import Colors from '@/components/colors/Colors'
import ColorsNew from '@/components/colors/ColorsNew'
import ColorsEdit from '@/components/colors/ColorsEdit'
export default [
  {
    path: '/colors',
    name: 'colors',
    component: Colors,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/colors/new',
    name: 'colorsNew',
    component: ColorsNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/colors/:id/edit',
    name: 'colorsEdit',
    component: ColorsEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/colorRoutes.js